
<template>
  <!--新增活动-->
  <div style="background-color: #fff">
    <x-addEdit
      ref="addEdit"
      :itemLayout="itemLayout"
      :formList="formList"
      :formKey="formKey"
      :addParam="addParam"
      :editParam="editParam"
      :detailParam="detailParam"
    >
      <template slot="limitTime" slot-scope="{formItem}">
<!--        v-if="formItem.show"-->
        <a-form-item
          :label="formItem.label"
          v-bind="itemLayout">
          <a-input-group compact>
            <a-input style="width: 80%" v-decorator="formItem.subList[0].props" :placeholder="formItem.subList[0].placeholder" />

            <a-select v-decorator="formItem.subList[1].props">
              <a-select-option v-for="(item, index) of formItem.subList[1].options" :key="index" :value="item.value">{{ item.label }}</a-select-option>
            </a-select>
          </a-input-group>
        </a-form-item>
      </template>

      <template slot="freeTime" slot-scope="{formItem}">
        <a-form-item
          :label="formItem.label"
          v-bind="itemLayout">
          <a-input-group compact>
            <a-input style="width: 80%" v-decorator="formItem.subList[0].props" :placeholder="formItem.subList[0].placeholder" />

            <a-select v-decorator="formItem.subList[1].props">
              <a-select-option v-for="(item, index) of formItem.subList[1].options" :key="index" :value="item.value">{{ item.label }}</a-select-option>
            </a-select>
          </a-input-group>
        </a-form-item>
      </template>

      <a-row slot="prizeConfig" style="padding-right: 24px">
        <a-col :span="itemLayout.labelCol.span"></a-col>
        <a-col :span="21">
          <p style="padding-bottom: 24px">此活动必须配置8个奖品，其中至少有一个“谢谢参与”</p>
          <a-table
            style="margin-bottom: 20px"
            :columns="columns"
            :data-source="dataSource"
            rowKey="sort"
            :pagination="false"
          >
            <template slot="pic" slot-scope="text">
              <img style="height: 44px" :src="text" alt="">
            </template>
            <template slot="action" slot-scope="text, record, index">
              <a-button @click="editPrize(record, index)" type="link">编辑</a-button>
            </template>
          </a-table>
          <a-button
            @click="addPrize"
            style="margin-bottom: 50px"
            type="dashed"
            block
            icon="add-plus"
            :disabled="dataSource.length >= 8"
          >添加</a-button>
        </a-col>
      </a-row>
    </x-addEdit>

    <!--新增奖品的弹窗-->
    <a-modal
      title="选择奖品"
      :visible="visible"
      @cancel="closePrize"
      @ok="$refs.prizeForm.handleSubmit();"
      :confirmLoading="btnLoading.loading"
      v-bind="$store.state.modalConfig"
      width="650px"
    >

      <x-addEdit
        ref="prizeForm"
        modalType="modal"
        :itemLayout="prizeLayout"
        :isSubmitBtn="false"
        :reqLoading="btnLoading"
        :formList="prizeList"
        :formKey="prizeKey"
        :addParam="prizeAddParam"
        :editParam="prizeEditParam"
        :detailParam="prizeDetailParam"
      />
    </a-modal>

    <!--选择奖品的弹窗-->
    <a-modal
      title="选择奖品"
      :visible="awardVisible"
      :confirmLoading="awardLoading.loading"
      @cancel="closeAward"
      @ok="selectConfirm"
      v-bind="$store.state.modalConfig"
    >
      <x-tabula
        ref="table"
        rowKey="productId"
        :excludeResetKey="['type', 'lotteryId']"
        :searchParams.sync="awardParams"
        @handleSelectChange="handleSelectChange"
        :searchList="awardSearch"
        :columns="awardColumns"
        :listApi="prizeListApi"
        :rowSelection="true"
      >
        <template slot="opt_name" slot-scope="{row}">
          <div style="display: flex; align-items: center">
            <div style="height: 44px; margin-right: 10px">
              <img style="height: 100%" :src="row.picUrl" alt="">
            </div>
            <span>{{ row.name }}</span>
          </div>
        </template>
      </x-tabula>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '@/utils/mixins';
import Common from '@/utils/common';
// const prizeType = [
//   { value: 1, label: '实物' },
//   { value: 2, label: '优惠券' },
//   { value: 3, label: '卡密' },
//   { value: 4, label: '积分' },
//   { value: 5, label: '谢谢参与' }
// ];
export default {
  name: 'addActivity',
  mixins: [fetchSelect],
  data () {
    const maxLen = { max: 9, message: '最多9位数字' };
    return {
      productIdCache: undefined,
      productNameCache: undefined,
      // 选择奖品弹窗
      selectPrize: [],
      awardLoading: { loading: false },
      awardVisible: false,
      awardParams: { name: undefined, type: undefined, lotteryId: undefined },
      awardSearch: [
        { props: ['name'], placeholder: '商品名称', options: [], inputType: 'input' }
      ],
      awardColumns: [
        { title: '商品名称', dataIndex: 'name', align: '', width: '', scopedSlots: { customRender: 'name' } },
        { title: '兑换价(积分)', dataIndex: 'point', align: '', width: '' },
        { title: '销量', dataIndex: 'sale', align: '', width: '' },
        { title: '库存', dataIndex: 'stock', align: '', width: '' }
      ],
      prizeListApi: {
        url: '/pm/product/prizeList',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },

      // 新增、编辑奖品列表
      recordData: {},
      isEditPrize: false,
      editIndex: -1,
      visible: false,
      btnLoading: { loading: false },
      prizeList: [
        {
          label: '奖品类型',
          inputType: 'select',
          options: [],
          handle: e => this.prizeTypeChange(e, 'change'),
          placeholder: '请选择奖品类型',
          props: ['prizeType', {
            rules: [{required: true, message: '请选择奖品类型'}]
          }]
        },
        {
          label: '选择奖品',
          inputType: 'input',
          options: [],
          placeholder: '请选择奖奖品',
          props: ['productId', {
            rules: [{required: true, message: '请选择奖品'}]
          }]
        },
        {
          label: '奖品名称',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入奖品名称',
          props: ['prizeName', {
            rules: [
              {required: true, message: '请输入奖品名称'},
              { max: 20, message: '奖品名称最多20位' }
            ]
          }]
        },
        {
          label: '奖品数量',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '可供抽奖的奖品数，抽完之后概率为0',
          props: ['prizeAmount', {
            rules: [
              {required: true, message: '请输入奖品数量'},
              { pattern: this.REG.nonnegativeInteger, message: this.MESSAGE.nonnegativeInteger },
              maxLen
            ]
          }]
        },
        {
          label: '中奖概率',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入中奖概率',
          props: ['prizeProbability', {
            rules: [
              {required: true, message: '请输入中奖概率'}, // 最多3位数字, 请输入非负数, 最多保留2位小数点
              { pattern: /^\d{0,3}(\.\d{0,2})?$/, message: '最大3位数，小数2位数且非负数' }
            ]
          }]
        },
        {
          label: '中奖限制',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '每个用户最多抽中几次，不填为无限制',
          props: ['prizeLimit', {
            rules: [
              { pattern: this.REG.nonnegativeInteger, message: this.MESSAGE.nonnegativeInteger },
              maxLen
            ]
          }]
        },
        {
          label: '奖品图片',
          inputType: 'upload',
          fileList: [],
          beforeHandle: Common.uploadBeforeHandle,
          uploadParam: {
            url: '/common/upload',
            iconUrl: 'iconUrl',
            iconName: 'fileName',

            action: this.$store.state.uploadUrlJava,
            accept: this.$store.state.imgAccept,
            headers: {},
            listType: 'picture',
            uploadType: 4
          },
          props: ['imageId', {
            rules: [{required: true, message: '请选择奖品图片'}]
          }]
        }
      ],
      prizeKey: {
        name: undefined
      },
      prizeAddParam: {
        url: '',
        reqHandle: this.prizeConfirm, // addParam、editParaM都会执行 reqHandle方法
        resHandle: '' // this.addResHandle
      },
      prizeEditParam: {
        url: '',
        resHandle: '' // this.editResHandle
      },
      prizeDetailParam: {
        url: '',
        resHandle: '' // this.detailResHandle
      },

      // 奖品配置 table
      columns: [
        { title: '排序', dataIndex: 'sort' },
        { title: '奖品图片', dataIndex: 'pic.url', scopedSlots: { customRender: 'pic' } },
        { title: '奖品名称', dataIndex: 'prizeName' },
        { title: '中奖概率(%)', dataIndex: 'prizeProbability' },
        { title: '奖品数量', dataIndex: 'prizeAmount' },
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' } }
      ],
      dataSource: [],

      // 新增奖品
      itemLayout: {
        labelCol: { span: 3 },
        wrapperCol: { span: 9 }
      },
      prizeLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 11 }
      },
      formList: [
        {
          cardHead: '基本信息',
          label: '活动标题',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入活动标题',
          props: ['title', {
            rules: [{required: true, message: '请输入活动标题'}]
          }]
        },
        {
          label: '消耗积分',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入消耗积分',
          props: ['point', {
            rules: [
              {required: true, message: '请输入消耗积分'},
              { pattern: this.REG.positiveInt, message: this.MESSAGE.positiveInt },
              maxLen
            ]
          }]
        },
        {
          slot: 'limitTime',
          inputType: 'input',
          label: '限制次数',
          subList: [
            {
              inputType: 'input',
              options: [],
              handle: '',
              placeholder: '请输入限制次数',
              props: ['limitTimes', {
                normalize: this.handleInputValue,
                rules: [{ pattern: this.REG.positiveInt, message: this.MESSAGE.positiveInt }, maxLen]
              }]
            },
            {
              inputType: 'select',
              options: [
                { label: '次/每天', value: 1 },
                { label: '次/永久', value: 2 }
              ],
              handle: '',
              placeholder: '',
              props: ['limitType', { initialValue: 1, rules: [] }]
            }
          ]
        },
        {
          slot: 'freeTime',
          label: '免费次数',
          inputType: 'input',
          subList: [
            {
              options: [],
              handle: '',
              placeholder: '请输入免费次数',
              props: ['freeTimes', {
                normalize: this.handleInputValue,
                rules: [
                  {required: true, message: '请输入免费次数'},
                  { pattern: this.REG.nonnegativeInteger, message: this.MESSAGE.nonnegativeInteger },
                  maxLen
                ]
              }]
            },
            {
              inputType: 'select',
              options: [
                { label: '次/每天', value: 1 },
                { label: '次/永久', value: 2 }
              ],
              handle: '',
              placeholder: '',
              props: ['freeType', { initialValue: 1, rules: [] }]
            }
          ]
        },
        {
          label: '活动时间',
          inputType: 'rangeTimePick',
          options: [],
          handle: '',
          placeholder: ['活动时间', '活动时间'],
          props: ['activityTime', {
            rules: [{ required: true, message: '请选择活动时间' }]
          }]
        },
        {
          label: '图片配置',
          inputType: 'upload',
          fileList: [],
          extra: '活动入口，展示给C端用户，格式为jpg、png、jpeg，图片大小不可大于1M',
          beforeHandle: Common.uploadBeforeHandle,
          uploadParam: {
            url: '/common/upload',
            iconUrl: 'imageUrl',
            iconName: 'fileName',

            action: this.$store.state.uploadUrlJava,
            accept: this.$store.state.imgAccept,
            headers: {},
            listType: 'picture',
            uploadType: 4
          },
          props: ['imageId', {
            rules: [{required: true, message: '请上传图片'}]
          }]
        },
        {
          slot: 'prizeConfig',
          cardHead: '奖品配置',
          label: '',
          inputType: 'text',
          options: [],
          handle: '',
          placeholder: '',
          props: ['', {
            rules: []
          }]
        }
      ],
      formKey: {
        title: undefined,
        point: undefined,
        limitTimes: undefined,
        limitType: undefined,
        freeTimes: undefined,
        freeType: undefined,
        activityTime: [],
        imageId: undefined
      },
      addParam: {
        url: '/pm/lottery',
        reqHandle: this.addReqHandle, // addParam、editParaM都会执行 reqHandle方法
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/pm/lottery/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/pm/lottery/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
  },
  methods: {
    handleInputValue (value, prevValue, allValues) {
      typeof value === 'number' && (value = String(value));
      return value;
    },
    /** 奖品类型选择事件 */
    prizeTypeChange (value, type) {
      this.selectPrize = []; // 打开弹窗或切换奖品类型，重置上一次选择商品的值
      this.awardParams.type = value;
      let product = this.prizeList.find(item => item.props && item.props[0] === 'productId'); // 奖品
      let amount = this.prizeList.find(item => item.props && item.props[0] === 'prizeAmount'); // 奖品数量
      type === 'change' && this.$refs.prizeForm.form.setFieldsValue({ productId: undefined });

      if (value === '4' || value === '5') {
        product.readOnly = false;
        product.click = '';
      } else {
        product.readOnly = true;
        product.click = this.openSelectPrize;
      }
      if (value === '4') {
        product.placeholder = '请输入积分数';
        product.label = '积分';
        product.props[1].rules = [ // 最多4位数字, 请输入正整数
          {required: true, message: '请输入积分数'},
          { max: 4, message: '最多4位数' },
          { pattern: this.REG.positiveInt, message: this.MESSAGE.positiveInt }
        ];
      } else {
        product.placeholder = '请选择奖品';
        product.label = '选择奖品';
        product.props[1].rules = [{ required: true, message: '请选择奖品' }];
      }

      let prizeRule = this.prizeList[1].props[1].rules[0];
      if (value === '5') {
        prizeRule.required = false;
        product.isShow = false;
        amount.isShow = false;
      } else {
        prizeRule.required = true;
        product.isShow = true;
        amount.isShow = true;
      }
    },
    resetFieldList () {
      let image = this.prizeList.find(item => item.props && item.props[0] === 'imageId');
      image.fileList = [];
    },
    getPrizeTypeSelect () {
      return new Promise(resolve => {
        this.dictionarySelect([{
          query: 'comu_lottery_prize_type',
          handle: (data) => {
            this.prizeList[0].options = data;
            resolve();
          }
        }]);
      });
    },
    /** 新增奖品 */
    async addPrize () {
      await this.getPrizeTypeSelect();
      this.prizeTypeChange('1');
      this.resetFieldList();
      this.visible = true;
    },
    /** 关闭弹窗（新增、编辑奖品） */
    closePrize () {
      this.isEditPrize = false;
      this.visible = false;
      this.productIdCache = undefined;
      this.productNameCache = undefined;
    },
    /** 奖品配置弹窗确定 */
    prizeConfirm (params) {
      this.checkSku({...params}).then(() => {
        if (this.selectPrize.length) {
          params.productId = this.selectPrize[0].productId;
          params.productName = this.selectPrize[0].name;
        } else if (this.productIdCache != undefined) {
          params.productId = this.productIdCache;
          params.productName = this.productNameCache;
        } else {
          if (['1', '2', '3', '6', '7'].some(item => item === params.prizeType)) { // 非积分、谢谢参与
            params.productName = params.productId; // params.productId 为名称
            params.productId = this.recordData.productName; // recordData.prizeName为 id
          }
        }

        let image = this.prizeList.find(item => item.props && item.props[0] === 'imageId');
        let url = image.fileList[0];
        params.sort = this.recordData.sort;
        params.id = this.recordData.id;
        params.lotteryId = this.recordData.lotteryId;
        params.pic = url;
        params.imageId = url.uid;
        console.log('EditPrize: ', this.dataSource.length, this.isEditPrize);
        if (this.dataSource.length < 8 && this.isEditPrize === false) { // 新增
          params.sort = this.dataSource.length + 1;
          this.dataSource.push(params);
        } else { // 编辑
          if (!params.hasOwnProperty('sort')) {
            params.sort = this.editIndex + 1;
          }
          this.dataSource[this.editIndex] = params;
          this.dataSource = [...this.dataSource];
        }

        this.isEditPrize = false;
        this.selectPrize = []; // 重置上一次选择商品的值
        image.fileList = [];
        this.visible = false;
        this.productIdCache = undefined;
        this.productNameCache = undefined;
      });
    },
    /** 检查奖品库存 */
    checkSku (params) {
      if (this.selectPrize.length) {
        params.productId = this.selectPrize[0].productId;
      } else if (this.productIdCache != undefined) {
        params.productId = this.productIdCache;
      } else {
        if (['1', '2', '3', '6', '7'].some(item => item === params.prizeType)) {
          params.productId = this.recordData.productName;
        }
      }

      return new Promise((resolve, reject) => {
        this.$post({
          url: '/pm/lottery/checkPrize',
          params: {
            productId: params.productId,
            prizeAmount: params.prizeAmount,
            prizeType: params.prizeType,
            lotteryId: this.recordData.lotteryId // 新增改参数为 undefined
          },
          btnLoading: this.awardLoading
        }).then(({ data }) => {
          resolve(true);
        }).catch(err => {
          reject(err);
        });
      });
    },
    /** 编辑奖品列表 */
    async editPrize (record, index) {
      await this.getPrizeTypeSelect();
      this.isEditPrize = true;
      this.editIndex = index;
      let row = { ...record };
      if (['1', '2', '3', '6', '7'].some(item => item === row.prizeType)) { // 非积分、谢谢参与
        let productName = row.productName;
        row.productName = row.productId;
        row.productId = productName;
      }
      this.recordData = row;
      this.resetFieldList();
      this.prizeTypeChange(row.prizeType);
      this.visible = true;
      this.$nextTick(() => {
        let item = {
          uid: row.pic.uid,
          name: row.pic.url,
          url: row.pic.url
        };
        let image = this.prizeList.find(item => item.props && item.props[0] === 'imageId');
        image.fileList[0] = item;
        this.$refs.prizeForm.form.setFieldsValue(row);
      });
    },

    addReqHandle (params) {
      let probability = this.dataSource.map(item => parseFloat(item.prizeProbability));
      let sum = 0;
      probability.forEach(item => {
        sum += item;
      });
      if (this.dataSource.length < 8) {
        this.$message.error('活动必须配置8个奖品');
        return false;
      } else if (this.dataSource.every(item => item.prizeType !== '5')) {
        this.$message.error('奖品类型至少有一个“谢谢参与”');
        return false;
      } else if (sum < 100) {
        this.$message.error('活动奖品总概率需要达到100');
        return false;
      }
      params.prizeList = this.dataSource;
      params.lotteryStartTime = params.activityTime[0].format('YYYY-MM-DD HH:mm:ss');
      params.lotteryEndTime = params.activityTime[1].format('YYYY-MM-DD HH:mm:ss');
      delete params.activityTime;
      return params;
    },
    detailResHandle (res) {
      res.prizeList && res.prizeList.forEach((el, index) => {
        el.pic.uid = el.imageId;
      });
      res.imageId = res.pic.imageId;
      res.imageUrl = res.pic.url;
      this.dataSource = res.prizeList;
      res.activityTime = [res.lotteryStartTime, res.lotteryEndTime];

      return res;
    },

    /** 打开选择奖品弹窗 */
    openSelectPrize () {
      let id = this.$route.query.id;
      id && (this.awardParams.lotteryId = this.$route.query.id); // 编辑选择商品时加上
      this.awardVisible = true;
    },
    /** 选择奖品事件，只能选择一个奖品 */
    handleSelectChange (rows) {
      if (rows && rows.length > 1) {
        this.$message.error('最多只能选择一个奖品');
      }
      this.selectPrize = rows;
    },
    /** 确定选择奖品 */
    selectConfirm () {
      this.productIdCache = this.selectPrize[0].productId;
      this.productNameCache = this.selectPrize[0].name;
      if (this.selectPrize.length > 1) {
        this.$message.error('最多只能关联一个奖品');
      } else {
        let awardItem = this.selectPrize[0];
        let str = `${awardItem.name} ${awardItem.point}`;
        this.$refs.prizeForm.form.setFieldsValue({ productId: str });
        this.handleCloseAward();
      }
    },
    handleCloseAward () {
      this.awardParams.name && (this.awardParams.name = undefined);// 重置搜索条件
      this.$nextTick(() => {
        this.awardVisible = false;
      });
    },
    /** 关闭弹窗（选择奖品） */
    closeAward () {
      this.selectPrize = [];
      this.handleCloseAward();
    },
    reqHandle (param) {
      return param;
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
